var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{attrs:{"align":"center","justify":"center"}},_vm._l((_vm.blog),function(info){return _c('div',{key:info.date,staticClass:"box_blog"},[_c('blog',{attrs:{"content":info}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }